import { Button, Col, Row, Select, Input, Spin, message, Icon } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Translate } from 'react-translated'
import F from "../../Functions";


const Option = Select.Option;

function Microsoft_booking(props) {
  const [user, setuser] = useState(props.user)
  const [loading, setloading] = useState(false)
  const [has_microsoft_booking, set_has_microsoft_booking] = useState("")
  const [microsoft_service_type, setMicrosoft_service_type] = useState([])
  const [isValidated, setisValidated] = useState(false)
  const [data, setdata] = useState({
    booking_page_name: "",
    booking_page_admin_email: "",
    booking_business_exist: false,
    microsoft_rs_setup_appointment_select: null,
    microsoft_vo_setup_appointment_select: null,
    microsoft_booking_page_inputted: false,
    microsoft_booking_page_permissions: false,
    microsoft_login: false,
    microsoft_rs_setup_appointment: false,
    microsoft_rs_setup_appointment_permissions: false,
    microsoft_vo_setup_appointment: false,
    microsoft_vo_setup_appointment_permissions: false,
    urls_generated: {}
  })


  useEffect(() => {
    setuser(props.user)
    set_has_microsoft_booking(props.user.microsoft_access_token || "")
    loadata()
  }, [props.user])


  const checkValidation = (cb) => {
    setloading(true)
    axios.get('/api/msbooking/check_booking_status').then(({ data: { success, error_response, flags, urls_generated } }) => {

      const { microsoft_booking_page_inputted,
        microsoft_booking_page_permissions,
        microsoft_login,
        microsoft_rs_setup_appointment,
        microsoft_rs_setup_appointment_permissions,
        microsoft_vo_setup_appointment,
        microsoft_vo_setup_appointment_permissions
      } = flags;
      setdata((prev) => ({
        ...prev,
        microsoft_booking_page_inputted,
        microsoft_booking_page_permissions,
        microsoft_login,
        microsoft_rs_setup_appointment,
        microsoft_rs_setup_appointment_permissions,
        microsoft_vo_setup_appointment,
        microsoft_vo_setup_appointment_permissions,
        urls_generated
      }))

    }).finally(() => cb && cb())
  }


  const loadata = () => {
    const data = data;

    if (props.user.microsoft_access_token) {
      setloading(true)
      checkValidation()
      axios.get('/api/msbooking/check_booking_page_exists', data).then(({ data: { success, booking_business_exist, booking_page_admin_email, booking_page_name, error_response } }) => {
        if (success && booking_business_exist) {
          setdata(prev => ({ ...prev, booking_business_exist, booking_page_admin_email, booking_page_name }))
          setloading(false)
          setisValidated(true)
          loadServiceType()
        } else if (success && !booking_business_exist) {
          setloading(true)
          axios.get('/api/msbooking/get_admin_mail_displayName').then(({ data: { success, booking_page_admin_email, error_response } }) => {
            if (success) {
              setdata(prev => ({ ...prev, booking_business_exist, booking_page_admin_email }))
              setloading(false)
              setisValidated(false)
            } else {
              setloading(false)
              message.error(error_response)
            }

          }).catch(err => message.error(err.message))
        } else if (!success) {
          setloading(false)
          message.error(error_response)
        }

      }).catch(err => {
        setloading(false)
        message.error(err.message)
      })

    }
  }

  const loadServiceType = () => {
    setloading(true)
    axios.get('/api/msbooking/list_service_types').then(({ data: { success, error_response, service_types_list, selected_services } }) => {
      if (success && !error_response) {
        setdata(prev => ({ ...prev, microsoft_rs_setup_appointment_select: selected_services.microsoft_rs_setup_appointment, microsoft_vo_setup_appointment_select: selected_services.microsoft_vo_setup_appointment }))
        setMicrosoft_service_type(service_types_list)
        setisValidated(true)
      }
      if (!success && error_response) {
        setisValidated(false)
        message.error(error_response)
      }

    }).catch(err => {
      message.error(err.message)
    }).finally(() => {
      setloading(false)
    })
  }


  const onChange = ({ target: { name, value } }) => {
    setdata((prev) => ({ ...prev, [name]: value }))
    if (['microsoft_rs_setup_appointment_select', 'microsoft_vo_setup_appointment_select'].includes(name)) {
      {
        name = name.split("_select")[0]
        props.updateField(name, value)
      }
    }
  }



  const connect_microsoft = () => {
    props.refreshData.loadingState(true)
    axios.get('/api/msbooking/get_login_link').then(({ data: { auth_url } }) => {
      window.location.replace(auth_url)
    })
  }



  const logoutMicrosoft = () => {
    props.refreshData.loadingState(true)
    axios.post('/api/msbooking/log_out').then(() => {
      message.success("Logged-Out Successfully")
      checkValidation(() => setloading(false))
      props.refreshData.loadingData()
    }).catch(err => {
      message.error(err.message)
    })
  }


  const validateFeilds = () => {
    const { booking_page_admin_email, booking_page_name } = data

    if (!data.booking_page_name) {
      message.error('Please Enter Booking Page Name')
    } else {
      setloading(true)
      axios.post("/api/msbooking/valdiate_login_email_business", { booking_page_name, booking_page_admin_email }).then(({ data: { error_response, success } }) => {
        if (!success && error_response) {
          setisValidated(false)
          message.error(error_response)
          setloading(false)
        }
        if (success && !error_response) {
          message.success("Validated Successfully")
          setloading(true)
          checkValidation()
          loadServiceType()
        }
      }).catch(err => {
        setloading(false)
        message.error(err.message)
      })
    }


  }

  const validateServiceType = () => {

    if (!data.microsoft_rs_setup_appointment_select || !data.microsoft_vo_setup_appointment_select) {
      message.error('Please Select Service Type')
    } else {
      setloading(true)
      axios
        .put("/api/users/" + user.id, {
          microsoft_rs_setup_appointment: user.microsoft_rs_setup_appointment,
          microsoft_vo_setup_appointment: user.microsoft_vo_setup_appointment,
        }).then(() => {
          checkValidation(() => {
            message.success("Validated Successfully")
            setloading(false)
          })
        })
    }


  }


  return (
    <Spin spinning={loading}>

      <div>
        <h2>
          Microsoft Status
        </h2>
        <Icon type={data.microsoft_login ? "check-circle" : "close-circle"} style={{ color: data.microsoft_login ? 'green' : 'red' }} /> Microsoft Login <br />
        <Icon type={data.microsoft_booking_page_inputted ? "check-circle" : "close-circle"} style={{ color: data.microsoft_booking_page_inputted ? 'green' : 'red' }} /> Microsoft Booking Page Inputted <br />
        <Icon type={data.microsoft_booking_page_permissions ? "check-circle" : "close-circle"} style={{ color: data.microsoft_booking_page_permissions ? 'green' : 'red' }} /> Microsoft Booking Page Permissions  <br />
        <Icon type={data.microsoft_rs_setup_appointment ? "check-circle" : "close-circle"} style={{ color: data.microsoft_rs_setup_appointment ? 'green' : 'red' }} /> Microsoft RS Setup Appointment  <br />
        <Icon type={data.microsoft_rs_setup_appointment_permissions ? "check-circle" : "close-circle"} style={{ color: data.microsoft_rs_setup_appointment_permissions ? 'green' : 'red' }} /> Microsoft RS Setup Appointment Permissions  <br />
        <Icon type={data.microsoft_vo_setup_appointment ? "check-circle" : "close-circle"} style={{ color: data.microsoft_vo_setup_appointment ? 'green' : 'red' }} /> Microsoft VO Setup Appointment  <br />
        <Icon type={data.microsoft_vo_setup_appointment_permissions ? "check-circle" : "close-circle"} style={{ color: data.microsoft_vo_setup_appointment_permissions ? 'green' : 'red' }} /> Microsoft VO Setup Appointment Permissions  <br />

        {data.microsoft_booking_page_inputted && data.microsoft_booking_page_permissions && <div>
          <div style={{ marginTop: 10 }}>
            <label>RS Service Url</label>
            <Input addonAfter={<Icon onClick={() => { navigator.clipboard.writeText(data.urls_generated.rs_service_url); message.success("Copied") }} style={{ cursor: 'pointer' }} type="copy" />} disabled type='text' value={data.urls_generated.rs_service_url} />
          </div>
          <div style={{ marginTop: 10 }}>
            <label>Vo Service Url</label>
            <Input addonAfter={<Icon onClick={() => { navigator.clipboard.writeText(data.urls_generated.vo_service_url); message.success("Copied") }} style={{ cursor: 'pointer' }} type="copy" />} disabled type='text' value={data.urls_generated.vo_service_url} />
          </div>
        </div>}
      </div>

      <div style={{ marginTop: 10 }}>
        {!has_microsoft_booking ? (
          <div>
            <h2>
              <Translate text={`Connect Microsoft Booking`} />
            </h2>
            <a onClick={connect_microsoft}
              role="button"
              tabIndex="0"
              style={{ cursor: 'pointer' }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  connect_microsoft();
                }
              }}
            >
              <Button>Connect Microsoft Booking</Button>
            </a>
            <br />
            <br />
          </div>
        ) : (
          <div>
            <h2>
              <Translate text={`Connect Microsoft Booking`} />
            </h2>
            <Button onClick={() => logoutMicrosoft()}>
              Logout
            </Button>
            <br />
            <br />
          </div>
        )}

        {has_microsoft_booking ? (
          <div style={{ margin: "10px 0px" }}>
            <h2>
              <Translate text={`Microsoft Settings`} />
            </h2>

            <Row style={{ marginBottom: 10 }} gutter={16}>
              <Col md={8} span={24}>
                <label>
                  Booking Page Name:
                </label>
                <Input type='text' value={data.booking_page_name} name='booking_page_name' onChange={onChange} placeholder="Booking page name" />
              </Col>
              <Col md={8} span={24}>
                <label>
                  Booking Page Admin Email:
                </label>
                <Input readOnly type='email' disabled value={data.booking_page_admin_email} name='booking_page_admin_email' onChange={onChange} placeholder="Booking page admin email" />
              </Col>
            </Row>
            <Button type='primary' ghost onClick={validateFeilds}>Validate</Button>

          </div>
        ) : null}

        {has_microsoft_booking && isValidated ? (
          <div style={{ marginTop: 10 }}>
            <Row gutter={16}>
              <Col md={8} className="inputField">
                <label>
                  <Translate text={`RS Setup Appointment Service Type`} />:
                </label>
                <Select
                  // value={user.calendly_rs_setup_appointment}
                  value={data.microsoft_rs_setup_appointment_select}
                  style={{ width: "100%" }}
                  onChange={(value) => onChange({ target: { name: "microsoft_rs_setup_appointment_select", value } })}
                >
                  <Option value={null}>
                    <Translate text={`Select Service Type`} />
                    ...
                  </Option>
                  {microsoft_service_type.map(
                    ({ service_id, service_name }, i) => (
                      <Option key={i} value={service_id}>
                        {service_name}
                      </Option>
                    )
                  )}
                </Select>
              </Col>
              <Col md={8} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`VO Setup Appointment Service Type`} />:
                  </label>
                  <Select
                    // defaultValue={user.calendly_vo_setup_appointment}
                    value={data.microsoft_vo_setup_appointment_select}
                    style={{ width: "100%" }}
                    onChange={(value) => onChange({ target: { name: "microsoft_vo_setup_appointment_select", value } })}
                  >
                    <Option value={null}>
                      <Translate text={`Select Service Type`} />
                      ...
                    </Option>
                    {microsoft_service_type.map(
                      ({ service_id, service_name }, i) => (
                        <Option key={i} value={service_id}>
                          {service_name}
                        </Option>
                      )
                    )}
                  </Select>
                </div>
              </Col>
            </Row>
            <Button style={{ marginBottom: 10 }} type='primary' ghost onClick={() => validateServiceType()}>Validate</Button>
          </div>
        ) : null}
      </div>
    </Spin>
  )
}

export default Microsoft_booking


// WEBPACK FOOTER //
// ./src/scenes/Profile/microsoft_booking.js